import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidLingo, TLingoAssignment } from '../../../../mechanics/rid-lingo/rid-lingo';

@Component({
  selector: 'app-lingo-page',
  imports: [RidLingo],
  templateUrl: './lingo-page.html',
})
export class LingoPage {
  protected readonly $router = inject(Router);

  protected readonly assignments: TLingoAssignment[] = [
    { word: 'stoel', klanken: ['s', 't', 'oe', 'l'] },
    { word: 'fiets', klanken: ['f', 'ie', 't', 's'] },
    { word: 'schaap', klanken: ['s', 'ch', 'aa', 'p'] },
    { word: 'bloem', klanken: ['b', 'l', 'oe', 'm'] },
  ];
}
